export const infoUser_test_auto = {
    isShop: false,
    uidentitie: "8ecfe5ee-926b-423e-8050-c911dd81c150-test-auto",
    email:
        "RlV0UWdXaFBJU1c4YlNHK3pxcVUreTJzdEtzU0h6akNUNmZuS1NUaXJvZlc2TXZJYjh4SFUzNzBIR1M4VGx2dg==",
    name: "franchise_testauto",
    firstname: "franchise_testauto",
    etataccount: "Activer",
    accounttype: "ADMIN",
    uuiduser: "411fe94c-c271-41b5-a877-bd7b9aa2ba0b",
    uuidprofile: "84fc7b78-8f8b-4803-8266-0c9cd95d97ac",
    maincolor: "#292929",
    secondarycolor: "#292929",
    profileAuthorization: {},
    configurationCategory: [],
    configurationItem: [],
    shop: {
        isShop: false,
        uuidFranchise: "8ecfe5ee-926b-423e-8050-c911dd81c147",
        schemaAdbFranchise: "franchise_testauto",
        Uid_User: "8ecfe5ee-926b-423e-8050-c911dd81c150-test-auto",
        ETKType: "3",
        AccountType: "Franchise",
        IdStore: "",
        Name_franchise: "Aures konnect",
        CommercialName: "franchise_testauto",
        posEditor: "",
    },
};

export const entity_test_auto = {
    "Nom commercial": "franchise_testauto",
    "Commercial name": "franchise_testauto",
    uid: "8ecfe5ee-926b-423e-8050-c911dd81c150-test-auto",
    adressAccount: "franchise_testauto",
    Profil: "SUPER ADMIN",
    Profile: "SUPER ADMIN",
    Nature: "Franchise",
    Kind: "Franchise",
    "Code postal": "franchise_testauto",
    "Zip code": "franchise_testauto",
    ville: "franchise_testauto",
    City: "franchise_testauto",
    "Compte de liasion": "",
    "Link account": "",
    "Compte parent": "Aures konnect",
    "Parent account": "Aures konnect",
    Pays: "France",
    Country: "France",
    Adresse: "franchise_testauto,franchise_testauto,franchise_testauto",
    Address: "franchise_testauto,franchise_testauto,franchise_testauto",
    franchise_schema: "franchise_testauto",
    IdStore: "",
    CRMId: "2207",
    "Type du compte": "Franchise",
    "Account type": "Franchise",
    childs_profilelink: [
        {
            uid: "Franshise-test-auto-boutique1",
            etat: "Activé",
            name: "Boutique1",
        },
        {
            uid: "Franshise-test-auto-boutique2",
            etat: "Activé",
            name: "Boutique2",
        },
    ],
    uuidFranchise: "8ecfe5ee-926b-423e-8050-c911dd81c147",
    uuidParentAccount: "8ecfe5ee-926b-423e-8050-c911dd81c147",
    uid_franchise_database_info:
        "8ecfe5ee-926b-423e-8050-c911dd81c150-test-auto",
    Téléphone1: "0123456789",
    "Phone 1": "0123456789",
    Téléphone2: "0123456789",
    phone2: "0123456789",
    phone1: "0123456789",
    "Phone 2": "0123456789",
    RaisonSociale: "franchise_testauto",
    "Company name": "franchise_testauto",
    numTva: "0123456",
    profile: [
        {
            uid: "84fc7b78-8f8b-4803-8266-0c9cd95d97ac",
            name: "SUPER ADMIN",
        },
    ],
    siteWeb: "franchise_testauto",
    "Site web": "franchise_testauto",
    siret: "0123456",
    codeApe: "012345",
    "Code APE": "012345",
    adresseEmail: "franchise_testauto@aureskonnect.com",
    EtkType: 3,
    posEditor: [
        {
            label: "",
            value: "",
        },
    ],
    isCatalogueTableExists: true,
    subRows: [
        {
            "Nom commercial": "Boutique1",
            "Commercial name": "Boutique1",
            uid: "Franshise-test-auto-boutique1",
            adressAccount: "Boutique1",
            Profil: "SUPER ADMIN",
            Profile: "SUPER ADMIN",
            Nature: "Boutique",
            Kind: "Boutique",
            "Code postal": "Boutique1",
            "Zip code": "Boutique1",
            ville: "Boutique1",
            City: "Boutique1",
            "Compte de liasion": "",
            "Link account": "",
            "Compte parent": "franchise_testauto",
            "Parent account": "franchise_testauto",
            Pays: "France",
            Country: "France",
            Adresse: "Boutique1,Boutique1,Boutique1",
            Address: "Boutique1,Boutique1,Boutique1",
            franchise_schema: "franchise_testauto",
            IdStore: "2",
            CRMId: "019178",
            "Type du compte": "Boutique",
            "Account type": "Boutique",
            childs_profilelink: null,
            uuidFranchise: "8ecfe5ee-926b-423e-8050-c911dd81c150-test-auto",
            uuidParentAccount: "8ecfe5ee-926b-423e-8050-c911dd81c150-test-auto",
            uid_franchise_database_info: "454ea7ad-562d-4b32-8d70-b28da662470a",
            Téléphone1: "0123456789",
            "Phone 1": "0123456789",
            Téléphone2: "0123456789",
            phone2: "0123456789",
            phone1: "0123456789",
            "Phone 2": "0123456789",
            RaisonSociale: "Boutique1",
            "Company name": "Boutique1",
            numTva: "012",
            profile: [
                {
                    uid: "84fc7b78-8f8b-4803-8266-0c9cd95d97ac",
                    name: "SUPER ADMIN",
                },
            ],
            siteWeb: "Boutique1",
            "Site web": "Boutique1",
            siret: "0123",
            codeApe: "012",
            "Code APE": "012",
            adresseEmail: "Boutique1@t.com",
            EtkType: 3,
            posEditor: [
                {
                    label: "",
                    value: "",
                },
            ],
            isCatalogueTableExists: true,
            subRows: [],
        },
        {
            "Nom commercial": "Boutique2",
            "Commercial name": "Boutique2",
            uid: "Franshise-test-auto-boutique2",
            adressAccount: "Boutique2",
            Profil: "SUPER ADMIN",
            Profile: "SUPER ADMIN",
            Nature: "Boutique",
            Kind: "Boutique",
            "Code postal": "Boutique2",
            "Zip code": "Boutique2",
            ville: "Boutique2",
            City: "Boutique2",
            "Compte de liasion": "",
            "Link account": "",
            "Compte parent": "franchise_testauto",
            "Parent account": "franchise_testauto",
            Pays: "France",
            Country: "France",
            Adresse: "Boutique2,Boutique2,Boutique2",
            Address: "Boutique2,Boutique2,Boutique2",
            franchise_schema: "franchise_testauto",
            IdStore: "3",
            CRMId: "019180",
            "Type du compte": "Boutique",
            "Account type": "Boutique",
            childs_profilelink: null,
            uuidFranchise: "8ecfe5ee-926b-423e-8050-c911dd81c150-test-auto",
            uuidParentAccount: "8ecfe5ee-926b-423e-8050-c911dd81c150-test-auto",
            uid_franchise_database_info:
                "8ecfe5ee-926b-423e-8050-c911dd81c150-test-auto",
            Téléphone1: "0123456789",
            "Phone 1": "0123456789",
            Téléphone2: "0123456789",
            phone2: "0123456789",
            phone1: "0123456789",
            "Phone 2": "0123456789",
            RaisonSociale: "Boutique2",
            "Company name": "Boutique2",
            numTva: "012",
            profile: [
                {
                    uid: "84fc7b78-8f8b-4803-8266-0c9cd95d97ac",
                    name: "SUPER ADMIN",
                },
            ],
            siteWeb: "Boutique2",
            "Site web": "Boutique2",
            siret: "012",
            codeApe: "0",
            "Code APE": "0",
            adresseEmail: "Boutique2@t.om",
            EtkType: 3,
            posEditor: [
                {
                    label: "",
                    value: "",
                },
            ],
            isCatalogueTableExists: true,
            subRows: [],
        },
    ],
};
